import { Textarea } from '~/components';

export const FormTextarea = ({
  value,
  label,
  placeholder,
  rows,
  optional,
  onChange,
}: {
  value: string;
  label?: string;
  placeholder?: string;
  rows?: number;
  optional?: boolean;
  onChange: (value: string) => void;
}) => {
  return (
    <div className="space-y-4">
      {label && (
        <div>
          <span>{label}</span>
          {optional && (
            <span className="lowercase text-muted-foreground"> Optional</span>
          )}
        </div>
      )}

      <Textarea
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        rows={rows || 5}
      />
    </div>
  );
};
